import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Box,
} from '@mui/material';
import { Dispatch, FC, SetStateAction, useContext } from 'react';

import MilestonesList from '@components/MilestonesList/MilestonesList';
import { medium } from '@styles/fontWeights';

import AccountStrength from './AccountStrength';
import useAccountCompletion from '../hooks/useAccountCompletion';
import useClaimNow from '../hooks/useClaimNow';
import { authContext } from '@staffedupusa/shared-components';
import useCountdownTime from '../hooks/useCountdownTime';

type CompletionModalProps = {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
};

const CompletionModal: FC<CompletionModalProps> = ({ isOpen, setIsOpen }) => {
  const milestones = useAccountCompletion();
  const claimNow = useClaimNow();
  const { authData } = useContext(authContext);

  const dtTimestamp = authData?.user?.dt_timestamp as string;
  const { days, hours, minutes, seconds } = useCountdownTime(dtTimestamp);

  const isComplete = milestones.every(({ complete }) => complete);

  const handleClaim = async () => {
    await claimNow();
    setIsOpen(false);
  };

  return (
    <Dialog
      open={isOpen}
      onClose={() => setIsOpen(false)}
      maxWidth="sm"
      fullWidth
      sx={{
        marginX: 'auto',
      }}
      classes={{
        paper: 'completion-paper',
      }}
    >
      <DialogTitle sx={{ paddingTop: '30px' }}>
        <AccountStrength />
      </DialogTitle>
      <DialogContent sx={{ textAlign: 'center' }}>
        <Typography
          color="secondary.main"
          variant="subtitle1"
          fontWeight={medium}
          maxWidth="450px"
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            margin: '0 auto 0 !important',
            flexDirection: { xs: 'column', sm: 'row' },
          }}
        >
          Complete your checklist within 7 days to get your first month free!
        </Typography>

        <Typography variant="h6" fontWeight={medium} flexShrink="0" sx={{ margin: '0 auto 50px !important' }}>
          {days} <Box component="span" sx={{ display: { xs: 'none', sm: 'inline-block' } }}>Days</Box> :{" "}
          {hours} <Box component="span" sx={{ display: { xs: 'none', sm: 'inline-block' } }}>Hours</Box> :{" "}
          {minutes} <Box component="span" sx={{ display: { xs: 'none', sm: 'inline-block' } }}>Mintues</Box> :{" "}
          {seconds} <Box component="span" sx={{ display: { xs: 'none', sm: 'inline-block' } }}>Seconds</Box>
        </Typography>

        <MilestonesList milestones={milestones} />
        <Button
          variant="contained"
          disabled={!isComplete}
          onClick={handleClaim}
          startIcon={
            isComplete ? <LockOpenOutlinedIcon /> : <LockOutlinedIcon />
          }
        >
          Claim now
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default CompletionModal;
